import { PerformanceMetrics } from 'pages/Campaign/PerformanceResults/api/usePerformanceResultsNotification/usePerformanceResultsNotification';

export const getCampaignNotificationNumber = (
  isShowFirst30DaysOption: boolean,
  elapsedDays: number,
  revealedMetric?: PerformanceMetrics[],
) => {
  if (!isShowFirst30DaysOption) {
    return 0;
  }

  let notificationNumber = 0;

  if (elapsedDays >= 5 && !revealedMetric?.includes('totalShoppersDelivered')) {
    notificationNumber += 1;
  }

  if (elapsedDays >= 10 && !revealedMetric?.includes('netNewShoppersDelivered')) {
    notificationNumber += 1;
  }

  if (elapsedDays >= 15 && !revealedMetric?.includes('crmLeadOpportunities')) {
    notificationNumber += 1;
  }

  if (elapsedDays >= 30 && !revealedMetric?.includes('vinsSold')) {
    notificationNumber += 1;
  }

  return notificationNumber;
};
